export default "__VITE_ASSET__ad4e91d0__"